<script lang="ts" module>
  import { css } from "@agapi/ui/panda/css";
  import { stack, type StackStyles } from "@agapi/ui/panda/patterns";
  import { miniCartStyles } from "./minicart.styles";

  export interface MiniCartProps {
    progress: number;
  }
</script>

<script lang="ts">
  const { progress = 0 }: MiniCartProps = $props();

  // TODO: break out to style file
  const progressBarStyles = css({
    minHeight: "items.sm",
    bg: "surface.secondary.contrast.foreground",
    rounded: "full",
    maxWidth: "100%",
    transition: "0.2s ease",
  });

  const classes = miniCartStyles.raw();
</script>

<div class={stack(classes.progressBarRoot as StackStyles)}>
  <div class={progressBarStyles} style={`width: ${progress}%`}></div>
</div>
